import React from 'react'

const Weddingevent = () => {
  return (
    <div>Weddingevent</div>
  )
}

export default Weddingevent